"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0 15.733c-4.133 0-7.483-3.35-7.483-7.483S7.867 4.517 12 4.517s7.483 3.35 7.483 7.483-3.35 7.483-7.483 7.483"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.599 12V8.354L15.913 12l-6.314 3.645z"
  })]
}), 'PlayCircle');
